import { isEmpty } from 'lodash';
import { Control, FieldValues, useFormContext } from 'react-hook-form';

type Result = {
  control: Control<FieldValues, any>;
  selectedData: {
    state: string[];
  };
  setVal: (newValue: string[]) => void;
};

type Args = {
  name: string;
};

const useRHFCheckboxSelect = (args: Args): Result => {
  const { name } = args;
  const { control, setValue, watch } = useFormContext();

  const selectedData = {
    state: watch(name),
  };

  const setVal = (newSeriesData: string[]) => {
    if (isEmpty(newSeriesData)) {
      setValue(name, []);
    }

    setValue(name, newSeriesData);
  };

  return {
    control,
    selectedData,
    setVal,
  };
};

export default useRHFCheckboxSelect;
